import Typography from "@mui/material/Typography";
import { FC } from "react";
import { GameWrapper } from "./styled";

interface GameInfoProps {
  name?: string | null;
  studio?: string | null;
  maxWidth: string;
  titleVariant: "bodySMedium" | "bodySSemiBold";
  subtitleVariant: "bodyXSSemiBold" | "bodyXSMedium";
}

const GameInfo: FC<GameInfoProps> = ({
  name,
  studio,
  maxWidth,
  titleVariant,
  subtitleVariant,
}) => (
  <GameWrapper maxWidth={maxWidth}>
    <Typography variant={titleVariant}>{name}</Typography>
    <Typography variant={subtitleVariant}>{studio}</Typography>
  </GameWrapper>
);

export default GameInfo;
